export const eReminderDates = {
    NONE: 'None',
    ON_TIME: 'On Time',
    '1_DAY_BEFORE': '1 Day Before',
    '3_DAYS_BEFORE': '3 Days Before',
    WEEK_BEFORE: 'A Week Before'
};
